class ProductAccordionsHorizontal extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTabChange = this.handleTabChange.bind(this)

    this.externalEls.trigger?.elements.forEach(triggerEl => {
      this.listeners.add(triggerEl, 'click', this.handleTabChange)
    })
    this.els.trigger?.elements.forEach(triggerEl => {
      this.listeners.add(triggerEl, 'click', this.handleTabChange)
    })
  }

  handleTabChange (event) {
    const clickedTrigger = event.target

    this.els.trigger?.elements.forEach(triggerEl => {
      triggerEl.setAttribute(
        'aria-pressed',
        triggerEl.dataset.tab === clickedTrigger.dataset.tab,
      )
    })

    this.els.panel?.elements.forEach(panelEl => {
      panelEl.setAttribute(
        'aria-hidden',
        panelEl.dataset.tab !== clickedTrigger.dataset.tab,
      )
    })
  }
}

if (!customElements.get('product-accordions-horizontal')) {
  customElements.define(
    'product-accordions-horizontal',
    ProductAccordionsHorizontal,
  )
}
